import type { FeatureIcon } from "../content/landingContent.js";

interface ProcessIconProps {
  icon: FeatureIcon;
}

const ProcessIcon = ({ icon }: ProcessIconProps) => (
  <span className={`landing-process-icon is-${icon}`} aria-hidden="true">
    <svg viewBox="0 0 48 48" focusable="false">
      {icon === "action" && <><path d="M12 35 31 16l5 5-19 19-7 1 2-6Z" /><path d="m28 19 5 5M13 34l4 4" /></>}
      {icon === "resolve" && <><path d="M24 7 38 15v17L24 41 10 32V15l14-8Z" /><path d="m17 23 5 5 10-11" /></>}
      {icon === "narrate" && <><path d="M9 11h30v23H24l-8 7v-7H9V11Z" /><path d="M16 19h16M16 25h11" /></>}
    </svg>
  </span>
);

export default ProcessIcon;
